import { useQuery } from '@apollo/client';
import useDialog from 'hooks/useDialog';
import { GET_CHAIN } from 'graphql/secure/queries/chain.queries';
import { useParams } from 'react-router-dom';
import { IChain } from 'FeatureModules/ComponentChain/types/chain.types';

const useComponentChain = () => {
  const { id } = useParams<{ id: string }>();
  const { openDialog } = useDialog();
  const { data, loading, error } = useQuery<{
    chain: IChain;
  }>(GET_CHAIN, { variables: { id } });

  const componentChain = data?.chain;

  const handleEditComponentChain = (chain: IChain) => {
    openDialog({
      type: 'EDIT_CHAIN',
      props: {
        chain,
      },
    });
  };

  return {
    componentChain,
    loading,
    error,
    handleEditComponentChain,
  };
};

export default useComponentChain;
